import { useRef, useState, useCallback, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import AtomBackground from './Atombackground'
import Reveal from './Reveal'
import videoSrc from '../assets/Videopresentacion.mp4'
import fotoSrc from '../assets/imagen.png'
import fotoSrc2 from '../assets/imagen2.png'

const milestones = [
  {
    year: '2016',
    title: 'Inicio de actividad docente',
    text: 'Desarrollo de una metodología centrada en comprensión real y razonamiento.',
  },
  {
    year: '2019',
    title: 'Fundación de IDM Medicina en Mar del Plata',
    text: 'Nacimiento de una comunidad enfocada en transformar la manera de aprender medicina.',
  },
  {
    year: '2021',
    title: 'Lanzamiento de los primeros cursos online',
    text: 'Más de 1.000 alumnos formados durante el primer año digital.',
  },
  {
    year: '2026',
    title: 'Comunidad consolidada a nivel internacional',
    text: '210k+ seguidores, millones de reproducciones y 6 programas activos ayudando estudiantes de medicina en todo el mundo.',
  },
]

function MoleculeDecor() {
  return (
    <svg
      width="140" height="140" viewBox="0 0 120 120"
      className="absolute -top-6 -right-6 opacity-[0.06] pointer-events-none"
      fill="none"
    >
      <circle cx="60" cy="60" r="40" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="60" cy="60" r="25" stroke="#C9A84C" strokeWidth="0.5"/>
      <circle cx="60" cy="20" r="6" fill="#C9A84C"/>
      <circle cx="60" cy="100" r="6" fill="#C9A84C"/>
      <circle cx="20" cy="60" r="6" fill="#C9A84C"/>
      <circle cx="100" cy="60" r="6" fill="#C9A84C"/>
      <line x1="60" y1="20" x2="60" y2="100" stroke="#C9A84C" strokeWidth="0.5"/>
      <line x1="20" y1="60" x2="100" y2="60" stroke="#C9A84C" strokeWidth="0.5"/>
    </svg>
  )
}

function TimelineDecorPanel() {
  return (
    <motion.div
      className="hidden lg:flex flex-col justify-center items-center gap-0 h-full"
      initial={{ opacity: 0, x: -16 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="relative flex items-center justify-center" style={{ width: 220, height: 220 }}>
        <svg
          viewBox="0 0 200 200"
          width="220" height="220"
          fill="none"
          style={{ opacity: 0.1, position: 'absolute' }}
        >
          <circle cx="100" cy="100" r="80" stroke="#C9A84C" strokeWidth="1"/>
          <circle cx="100" cy="100" r="55" stroke="#C9A84C" strokeWidth="0.6"/>
          <circle cx="100" cy="100" r="30" stroke="#C9A84C" strokeWidth="0.4"/>
          <line x1="100" y1="20" x2="100" y2="180" stroke="#C9A84C" strokeWidth="0.5"/>
          <line x1="20" y1="100" x2="180" y2="100" stroke="#C9A84C" strokeWidth="0.5"/>
          <line x1="43" y1="43" x2="157" y2="157" stroke="#C9A84C" strokeWidth="0.4"/>
          <line x1="157" y1="43" x2="43" y2="157" stroke="#C9A84C" strokeWidth="0.4"/>
          <circle cx="100" cy="20" r="5" fill="#C9A84C"/>
          <circle cx="100" cy="180" r="5" fill="#C9A84C"/>
          <circle cx="20" cy="100" r="5" fill="#C9A84C"/>
          <circle cx="180" cy="100" r="5" fill="#C9A84C"/>
          <circle cx="43" cy="43" r="3.5" fill="#C9A84C"/>
          <circle cx="157" cy="43" r="3.5" fill="#C9A84C"/>
          <circle cx="43" cy="157" r="3.5" fill="#C9A84C"/>
          <circle cx="157" cy="157" r="3.5" fill="#C9A84C"/>
          <circle cx="100" cy="100" r="8" fill="#C9A84C"/>
        </svg>
        <div className="relative z-10 flex flex-col items-center gap-1 text-center">
          <span
            className="font-display font-black"
            style={{ fontSize: 10, letterSpacing: '0.2em', color: 'var(--gold)', opacity: 0.6, textTransform: 'uppercase' }}
          >
            Trayectoria
          </span>
          <span
            className="font-display font-black"
            style={{ fontSize: 36, color: 'var(--gold)', lineHeight: 1 }}
          >
            10+
          </span>
          <span
            className="font-body font-light"
            style={{ fontSize: 11, color: 'var(--ink-3)', letterSpacing: '0.06em' }}
          >
            años enseñando
          </span>
        </div>
      </div>
      <motion.p
        className="font-body font-light italic text-center"
        style={{ fontSize: 11, color: 'var(--ink-3)', lineHeight: 1.75, letterSpacing: '0.02em', maxWidth: 200, marginTop: 16 }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.5, duration: 0.6 }}
      >
        "Cada año, más estudiantes comprenden medicina de una manera diferente."
      </motion.p>
    </motion.div>
  )
}

/* ─── SVG icons ─────────────────────────────────── */
const IconPlay = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8 5.14v14l11-7-11-7z"/>
  </svg>
)
const IconPause = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
  </svg>
)
const IconVolume = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"/>
  </svg>
)
const IconMuted = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06A8.99 8.99 0 0 0 17 18.73l2 2L20.73 19l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
  </svg>
)
const IconFullscreen = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
  </svg>
)

function formatTime(s) {
  if (!s || !isFinite(s)) return '0:00'
  const m = Math.floor(s / 60)
  const sec = Math.floor(s % 60)
  return `${m}:${sec.toString().padStart(2, '0')}`
}

/* ── VideoBlock con controles custom gold ───────── */
function VideoBlock({ title, delay = 0 }) {
  const videoRef = useRef(null)
  const containerRef = useRef(null)
  const progressRef = useRef(null)
  const hideTimer = useRef(null)

  const [playing, setPlaying] = useState(false)
  const [muted, setMuted] = useState(false)
  const [currentTime, setCurrentTime] = useState(0)
  const [duration, setDuration] = useState(0)
  const [buffered, setBuffered] = useState(0)
  const [showControls, setShowControls] = useState(true)
  const [started, setStarted] = useState(false)
  const [loading, setLoading] = useState(false)

  const resetHide = useCallback(() => {
    clearTimeout(hideTimer.current)
    setShowControls(true)
    if (playing) {
      hideTimer.current = setTimeout(() => setShowControls(false), 3000)
    }
  }, [playing])

  useEffect(() => {
    if (playing) resetHide()
    else { clearTimeout(hideTimer.current); setShowControls(true) }
    return () => clearTimeout(hideTimer.current)
  }, [playing, resetHide])

  useEffect(() => {
    const v = videoRef.current
    if (!v) return
    const onTime = () => {
      setCurrentTime(v.currentTime)
      if (v.buffered.length > 0) setBuffered(v.buffered.end(v.buffered.length - 1))
    }
    const onDur = () => setDuration(v.duration)
    const onPlay = () => { setPlaying(true); setLoading(false) }
    const onPause = () => setPlaying(false)
    const onEnded = () => { setPlaying(false); setStarted(false) }
    const onWait = () => setLoading(true)
    const onCan = () => setLoading(false)

    v.addEventListener('timeupdate', onTime)
    v.addEventListener('durationchange', onDur)
    v.addEventListener('loadedmetadata', onDur)
    v.addEventListener('play', onPlay)
    v.addEventListener('pause', onPause)
    v.addEventListener('ended', onEnded)
    v.addEventListener('waiting', onWait)
    v.addEventListener('canplay', onCan)
    v.addEventListener('canplaythrough', onCan)
    return () => {
      v.removeEventListener('timeupdate', onTime)
      v.removeEventListener('durationchange', onDur)
      v.removeEventListener('loadedmetadata', onDur)
      v.removeEventListener('play', onPlay)
      v.removeEventListener('pause', onPause)
      v.removeEventListener('ended', onEnded)
      v.removeEventListener('waiting', onWait)
      v.removeEventListener('canplay', onCan)
      v.removeEventListener('canplaythrough', onCan)
    }
  }, [])

  const togglePlay = useCallback(async () => {
    const v = videoRef.current
    if (!v) return
    resetHide()
    if (v.paused) {
      try { await v.play(); setStarted(true) } catch (e) { console.warn(e) }
    } else {
      v.pause()
    }
  }, [resetHide])

  const toggleMute = useCallback(() => {
    const v = videoRef.current
    if (!v) return
    v.muted = !v.muted
    setMuted(v.muted)
    resetHide()
  }, [resetHide])

  const handleSeek = useCallback((e) => {
    const v = videoRef.current
    const bar = progressRef.current
    if (!v || !bar || !duration) return
    const rect = bar.getBoundingClientRect()
    const clientX = e.touches ? e.touches[0].clientX : e.clientX
    const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width))
    v.currentTime = ratio * duration
    resetHide()
  }, [duration, resetHide])

  const handleFullscreen = useCallback(() => {
    const v = videoRef.current
    const c = containerRef.current
    // iOS Safari solo soporta fullscreen en el elemento <video>
    if (v && v.webkitEnterFullscreen) { v.webkitEnterFullscreen(); return }
    if (document.fullscreenElement) {
      document.exitFullscreen?.()
    } else {
      c?.requestFullscreen?.() || c?.webkitRequestFullscreen?.()
    }
    resetHide()
  }, [resetHide])

  const progress = duration > 0 ? currentTime / duration : 0
  const buffPct = duration > 0 ? (buffered / duration) * 100 : 0

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-col gap-4"
    >
      {/* label */}
      {title && (
        <div className="flex items-center gap-3">
          <span style={{ display: 'inline-block', width: 18, height: 1, background: 'var(--gold)', opacity: 0.7 }}/>
          <span
            className="font-display font-black uppercase tracking-[0.16em]"
            style={{ fontSize: 10, color: 'var(--gold)', opacity: 0.85 }}
          >
            {title}
          </span>
        </div>
      )}

      {/* marco premium */}
      <div style={{
        position: 'relative',
        padding: 3,
        background: 'linear-gradient(135deg, rgba(201,168,76,0.5) 0%, rgba(201,168,76,0.06) 45%, rgba(201,168,76,0.0) 55%, rgba(201,168,76,0.3) 100%)',
        boxShadow: '0 0 0 1px rgba(201,168,76,0.07), 0 24px 64px rgba(0,0,0,0.5)',
      }}>
        {/* esquinas decorativas */}
        {[
          { top: -7, left: -7, borderTop: '2px solid var(--gold)', borderLeft: '2px solid var(--gold)' },
          { top: -7, right: -7, borderTop: '2px solid var(--gold)', borderRight: '2px solid var(--gold)' },
          { bottom: -7, left: -7, borderBottom: '2px solid var(--gold)', borderLeft: '2px solid var(--gold)' },
          { bottom: -7, right: -7, borderBottom: '2px solid var(--gold)', borderRight: '2px solid var(--gold)' },
        ].map((s, i) => (
          <div key={i} aria-hidden style={{
            position: 'absolute', width: 16, height: 16,
            pointerEvents: 'none', zIndex: 10, opacity: 0.75, ...s,
          }}/>
        ))}

        {/* contenedor 16:9 */}
        <div
          ref={containerRef}
          onMouseMove={resetHide}
          onTouchStart={resetHide}
          style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%',
            height: 0,
            overflow: 'hidden',
            background: '#050505',
          }}
        >
          {/*
            CLAVE para iOS/Android:
            - src directo en <video> (no en <source>) — Vite bundlea la URL correctamente
            - playsInline sin autoPlay (iOS bloquea autoPlay con sonido)
            - preload="metadata" muestra primer frame como poster
            - SIN controls nativos → usamos los custom de abajo
          */}
         <video
  ref={videoRef}
  src={videoSrc}
  playsInline
  webkit-playsinline="true"
  preload="auto"
  muted={muted}
  controls={false}
  poster={fotoSrc2}
  onClick={togglePlay}
  style={{
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    background: '#000',
  }}
/>

          {/* overlay de play grande — solo antes del primer play */}
          <AnimatePresence>
            {!started && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0, scale: 0.94 }}
                transition={{ duration: 0.25 }}
                onClick={togglePlay}
                style={{
                  position: 'absolute', inset: 0, zIndex: 3,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer',
                  background: 'linear-gradient(180deg, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.52) 100%)',
                }}
              >
                <motion.div
                  whileHover={{ scale: 1.07 }}
                  whileTap={{ scale: 0.94 }}
                  style={{
                    width: 62, height: 62, borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgba(201,168,76,0.12)',
                    border: '1.5px solid rgba(201,168,76,0.65)',
                    backdropFilter: 'blur(8px)',
                    color: 'var(--gold)',
                    boxShadow: '0 0 28px rgba(201,168,76,0.18)',
                  }}
                >
                  <IconPlay />
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* spinner */}
          <AnimatePresence>
            {loading && started && (
              <motion.div
                initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                style={{
                  position: 'absolute', inset: 0, zIndex: 4,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  pointerEvents: 'none',
                }}
              >
                <div style={{
                  width: 30, height: 30, borderRadius: '50%',
                  border: '2px solid rgba(201,168,76,0.18)',
                  borderTop: '2px solid var(--gold)',
                  animation: 'idm-spin 0.75s linear infinite',
                }}/>
              </motion.div>
            )}
          </AnimatePresence>

          {/* click area para play/pause cuando ya empezó */}
          {started && (
            <div
              onClick={togglePlay}
              style={{ position: 'absolute', inset: 0, zIndex: 2, cursor: 'pointer' }}
            />
          )}

          {/* CONTROLES CUSTOM */}
          <AnimatePresence>
            {(showControls || !playing) && (
              <motion.div
                initial={{ opacity: 0, y: 4 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 4 }}
                transition={{ duration: 0.2 }}
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: 'absolute',
                  bottom: 0, left: 0, right: 0,
                  zIndex: 5,
                  padding: '32px 12px 10px',
                  background: 'linear-gradient(0deg, rgba(0,0,0,0.85) 0%, transparent 100%)',
                }}
              >
                {/* barra de progreso */}
                <div
                  ref={progressRef}
                  onClick={handleSeek}
                  onTouchStart={handleSeek}
                  style={{
                    position: 'relative',
                    width: '100%', height: 3,
                    background: 'rgba(255,255,255,0.1)',
                    cursor: 'pointer',
                    marginBottom: 9,
                    borderRadius: 2,
                  }}
                >
                  {/* buffered */}
                  <div style={{
                    position: 'absolute', top: 0, left: 0,
                    width: `${buffPct}%`, height: '100%',
                    background: 'rgba(201,168,76,0.22)',
                    borderRadius: 2, transition: 'width 0.3s',
                  }}/>
                  {/* played */}
                  <div style={{
                    position: 'absolute', top: 0, left: 0,
                    width: `${progress * 100}%`, height: '100%',
                    background: 'var(--gold)', borderRadius: 2,
                    transition: 'width 0.1s linear',
                  }}/>
                  {/* thumb */}
                  <div style={{
                    position: 'absolute', top: '50%',
                    left: `${progress * 100}%`,
                    transform: 'translate(-50%, -50%)',
                    width: 9, height: 9, borderRadius: '50%',
                    background: 'var(--gold)',
                    boxShadow: '0 0 5px rgba(201,168,76,0.55)',
                    transition: 'left 0.1s linear',
                  }}/>
                </div>

                {/* botones */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                  <button onClick={togglePlay} aria-label={playing ? 'Pausar' : 'Reproducir'} style={btnLg}>
                    {playing ? <IconPause /> : <IconPlay />}
                  </button>
                  <button onClick={toggleMute} aria-label={muted ? 'Activar sonido' : 'Silenciar'} style={btnSm}>
                    {muted ? <IconMuted /> : <IconVolume />}
                  </button>
                  <span style={{
                    fontFamily: 'monospace', fontSize: 10,
                    color: 'rgba(201,168,76,0.7)', letterSpacing: '0.05em',
                    userSelect: 'none', marginLeft: 2,
                  }}>
                    {formatTime(currentTime)}
                    <span style={{ color: 'rgba(255,255,255,0.22)', margin: '0 3px' }}>/</span>
                    {formatTime(duration)}
                  </span>
                  <div style={{ flex: 1 }}/>
                  <button onClick={handleFullscreen} aria-label="Pantalla completa" style={btnSm}>
                    <IconFullscreen />
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>

      {/* leyenda */}
      <p style={{
        fontSize: 10, color: 'rgba(201,168,76,0.32)',
        letterSpacing: '0.12em', textTransform: 'uppercase',
        textAlign: 'right', userSelect: 'none', paddingRight: 2,
      }}>
        IDM Medicina
      </p>

      <style>{`@keyframes idm-spin { to { transform: rotate(360deg); } }`}</style>
    </motion.div>
  )
}

const btnBase = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'rgba(201,168,76,0.08)',
  border: '1px solid rgba(201,168,76,0.22)',
  color: 'var(--gold)',
  cursor: 'pointer', flexShrink: 0,
  outline: 'none', padding: 0, lineHeight: 1,
  transition: 'background 0.18s, border-color 0.18s',
  borderRadius: 2,
}
const btnLg = { ...btnBase, width: 36, height: 36 }
const btnSm = { ...btnBase, width: 30, height: 30 }

/* ── timeline item ──────────────────────────────── */
function TimelineItem({ year, title, text, i }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -14 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.07 * i, duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
      className="relative flex gap-5 sm:gap-7 py-5"
    >
      <motion.div
        className="absolute -left-[25px] top-[26px] w-2 h-2 rounded-full"
        style={{ background: 'var(--gold)' }}
        initial={{ scale: 0 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.07 * i + 0.2, duration: 0.35, type: 'spring', stiffness: 400 }}
      />
      <span
        className="font-display font-black shrink-0 pt-0.5"
        style={{ fontSize: 'clamp(12px,2vw,14px)', color: 'var(--gold)', minWidth: '38px' }}
      >
        {year}
      </span>
      <div className="flex flex-col gap-1">
        <span
          className="font-display font-black"
          style={{ fontSize: 'clamp(12px,2vw,13px)', color: 'var(--ink)', lineHeight: 1.3 }}
        >
          {title}
        </span>
        <span
          className="font-body font-light leading-[1.65]"
          style={{ fontSize: 'clamp(12px,1.8vw,13px)', color: 'var(--ink-2)' }}
        >
          {text}
        </span>
      </div>
    </motion.div>
  )
}

function SectionLabel({ children }) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <span style={{ display: 'inline-block', width: 20, height: 1, background: 'var(--gold)', opacity: 0.7 }}/>
      <span
        className="font-display font-semibold uppercase tracking-[0.18em]"
        style={{ fontSize: 10, color: 'var(--gold)', opacity: 0.85 }}
      >
        {children}
      </span>
    </div>
  )
}

export default function SobreMi() {
  return (
    <section
      id="sobre"
      className="relative overflow-hidden"
      style={{ padding: 'clamp(72px,10vw,120px) clamp(20px,5vw,6vw)', background: 'var(--bg)' }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ width: '100%', height: '100%' }}
      >
        <AtomBackground />
      </div>

      <div
        aria-hidden
        className="absolute pointer-events-none"
        style={{
          left: '20%', top: '30%',
          width: 'min(60vw, 500px)', height: 'min(60vw, 500px)',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(201,168,76,0.05) 0%, transparent 65%)',
          filter: 'blur(80px)',
        }}
      />

      <div className="relative z-10">

        {/* HEADER */}
        <Reveal>
          <SectionLabel>Sobre mí</SectionLabel>
          <h2
            className="font-display font-black leading-[1.04] tracking-[-0.02em] mb-0"
            style={{ fontSize: 'clamp(1.8rem, 4vw, 3.2rem)', color: 'var(--ink)', maxWidth: 680 }}
          >
            Una trayectoria al servicio<br />
            de{' '}
            <em className="not-italic" style={{ color: 'var(--gold)' }}>tu aprendizaje</em>.
          </h2>
        </Reveal>

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_3fr] gap-12 lg:gap-16 mt-14 lg:mt-16 items-start">

          {/* LEFT: foto */}
          <Reveal delay={0.1}>
            <div className="relative">
              <div
                className="absolute -top-4 -right-4 w-14 h-14 pointer-events-none"
                style={{ borderTop: '2px solid var(--gold)', borderRight: '2px solid var(--gold)' }}
              />
              <div
                className="absolute -bottom-4 -left-4 w-14 h-14 pointer-events-none"
                style={{ borderBottom: '2px solid var(--gold)', borderLeft: '2px solid var(--gold)' }}
              />
              <MoleculeDecor />

              <motion.div
                className="w-full relative overflow-hidden"
                style={{ aspectRatio: '3/4', border: '1px solid var(--line)' }}
                whileHover={{ borderColor: 'rgba(201,168,76,0.35)' }}
                transition={{ duration: 0.3 }}
              >
                <img
                  src={fotoSrc}
                  alt="Foto profesional"
                  style={{
                    width: '100%', height: '100%',
                    objectFit: 'cover', objectPosition: 'center top',
                    display: 'block',
                  }}
                />
              </motion.div>

              <motion.div
                className="absolute bottom-8 -left-5 font-display font-black tracking-[0.1em] uppercase px-5 py-2.5"
                style={{ background: 'var(--gold)', color: '#000', fontSize: 10 }}
                initial={{ x: -8, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3, duration: 0.55, ease: [0.22,1,0.36,1] }}
              >
                Mentor
              </motion.div>
            </div>
          </Reveal>

          {/* RIGHT: copy + video */}
          <Reveal delay={0.2}>
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-4">
                <p
                  className="font-body font-light leading-[1.9]"
                  style={{ fontSize: 'clamp(13px,1.8vw,15px)', color: 'var(--ink-2)' }}
                >
                  Educador especializado en medicina, con más de 10 años de experiencia docente.
                  No creo en memorizar 400 diapositivas sin comprender realmente qué estás viendo.
                </p>
                <p
                  className="font-body font-light leading-[1.9]"
                  style={{ fontSize: 'clamp(13px,1.8vw,15px)', color: 'var(--ink-2)' }}
                >
                  Durante años vi estudiantes sentirse incapaces, cuando el problema no era su
                  inteligencia, sino la manera en que se les enseñaba medicina.
                  Por eso construí una metodología basada en claridad, razonamiento y comprensión real.
                </p>
                <p
                  className="font-body font-light leading-[1.9]"
                  style={{ fontSize: 'clamp(13px,1.8vw,15px)', color: 'var(--ink-2)' }}
                >
                  Mi enfoque parte de explicar los temas desde una lógica simple, utilizando ejemplos
                  cotidianos y razonamientos fáciles de visualizar. Una vez entendido el concepto,
                  avanzamos progresivamente hacia el funcionamiento preciso y profundo de cada mecanismo.
                  Todo está orientado al entendimiento, no a la memoria por sí sola.
                </p>

                <motion.div
                  className="flex gap-4 mt-1"
                  initial={{ opacity: 0, x: -8 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.25, ease: [0.22,1,0.36,1] }}
                >
                  <div style={{ width: 2, background: 'var(--gold)', opacity: 0.4, flexShrink: 0, borderRadius: 2 }}/>
                  <p
                    className="font-body font-light leading-[1.85] italic"
                    style={{ fontSize: 'clamp(13px,1.8vw,14px)', color: 'var(--ink-2)' }}
                  >
                    Mi obsesión es desarmar procesos complejos y transformarlos en explicaciones que
                    cualquier persona pueda comprender, incluso sin venir del mundo médico.
                  </p>
                </motion.div>
              </div>

              <motion.div
                style={{ height: 1, background: 'linear-gradient(90deg, var(--gold) 0%, transparent 100%)', opacity: 0.15 }}
                initial={{ scaleX: 0, originX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1, ease: [0.22,1,0.36,1] }}
              />

              <VideoBlock title="Conocé cómo enseño medicina" delay={0.15} />
            </div>
          </Reveal>
        </div>

        {/* TIMELINE SECTION */}
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_3fr] gap-12 lg:gap-16 mt-8 lg:mt-10 items-start">
          <TimelineDecorPanel />
          <Reveal delay={0.1}>
            <motion.div
              style={{ height: 1, background: 'linear-gradient(90deg, var(--gold) 0%, transparent 100%)', opacity: 0.15, marginBottom: 24 }}
              initial={{ scaleX: 0, originX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.1, ease: [0.22,1,0.36,1] }}
            />
            <div
              className="flex flex-col pl-7"
              style={{ borderLeft: '1px solid var(--line)' }}
            >
              {milestones.map((m, i) => (
                <TimelineItem key={m.year} {...m} i={i} />
              ))}
            </div>
          </Reveal>
        </div>

      </div>
    </section>
  )
}